<form [formGroup]="form">
  <app-form-field>
    <app-form-field-label>
      {{ 'general.international_code_l' | translate }}
    </app-form-field-label>
    <div class="d-flex align-items-end">
      <div class="col-3 p0">
        <im-form-field>
          <im-select
            [options]="internationalOptions()"
            [label]="'general.international_code_l' | translate"
            [hideLabel]="true"
            [placeholderOption]="{
              name: 'forms.select_international_type_l',
              value: '',
              disabled: true
            }"
            formControlName="international"
          >
            <app-hint label-more-info class="pl5">{{
              'general.dmv_aes_sms_l' | translate
            }}</app-hint>
            <ng-template let-item>{{ item.value }}</ng-template>
          </im-select>
        </im-form-field>
      </div>
      <div class="col pr0">
        <input
          appInput
          type="text"
          [readonly]="readonly()"
          [required]="required()"
          [placeholder]="'form.type_phone_l' | translate"
          formControlName="number"
          class="form-control w-100"
        />
      </div>
    </div>
  </app-form-field>
</form>
